module.exports = __webpack_public_path__ + "static/media/info_menu.0cfc412a.png";